import { render, staticRenderFns } from "./CN-N000012-24.vue?vue&type=template&id=98980a52&scoped=true&"
import script from "./CN-N000012-24.vue?vue&type=script&lang=js&"
export * from "./CN-N000012-24.vue?vue&type=script&lang=js&"
import style0 from "./CN-N000012-24.vue?vue&type=style&index=0&id=98980a52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98980a52",
  null
  
)

export default component.exports